import script from "./editTask.vue?vue&type=script&setup=true&lang=ts"
export * from "./editTask.vue?vue&type=script&setup=true&lang=ts"

import "./editTask.vue?vue&type=style&index=0&id=a6e64068&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6e64068"]])

export default __exports__